/** Interrupteur démo — localStorage seulement. */

export const FX_DASH_DEMO_KEY = "facturx_dash_demo";

export function readDashDemo(): boolean {
  try {
    return localStorage.getItem(FX_DASH_DEMO_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistDashDemo(on: boolean): void {
  try {
    localStorage.setItem(FX_DASH_DEMO_KEY, on ? "1" : "0");
  } catch {
    /* ignore */
  }
}
